module.exports = __webpack_public_path__ + "static/imperial-capital-10f81894b35c71914db3ebdb1585fa3c.png";